import { ContentSections } from '@project/cms/content-sections';
import { PageFrame, PageParams } from '@project/site/layout';

const SinglePageTemplate = (params: PageParams) => {
  const {
    pageContext: { pageInfo },
  } = params;

  return (
    <PageFrame {...params} pageName={pageInfo?.title}>
      <ContentSections data={pageInfo?.content} />
    </PageFrame>
  );
};

export default SinglePageTemplate;
